import { render, staticRenderFns } from "./CtaWidget.vue?vue&type=template&id=fe6a81a2&scoped=true"
import script from "./CtaWidget.vue?vue&type=script&lang=js"
export * from "./CtaWidget.vue?vue&type=script&lang=js"
import style0 from "./CtaWidget.vue?vue&type=style&index=0&id=fe6a81a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6a81a2",
  null
  
)

export default component.exports